var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loadingCheck)?_c('div',[_c('div',{staticClass:"loading-container"},[_c('b-spinner',{attrs:{"variant":"white"}}),_c('h4',[_vm._v(_vm._s(_vm.loadingMessage))]),_c('p',[_vm._v("از صبر و شکیبایی شما سپاسگزاریم")])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }